export default __webpack_public_path__ + "static/media/avatars.579c021c.svg";